'use strict';

angular.module('imagetrend.components')
    .controller('hlpBackController', ['$scope', '$rootScope', '$state', function ($scope, $rootScope, $state) {
        $scope.back = function () {
            if ($rootScope.$state.from.name != "" && $scope.navigationBack) {
                $state.go($rootScope.$state.from.name, $rootScope.$state.from.params);
            }
            else {
                if ($scope.params == null) {
                    $scope.params = {};
                }
                $state.go($scope.state, $scope.params);
            }            
        }
    }])
    .directive('hlpBack', ['Format', function (Format) {
        return {
            restrict: 'AE',
            replace: true,
            scope: {
                id: '@?',
                label: '@?',
                title: '@?',
                classes: '@?',
                state: '@?',
                params: '=?',
                navigationBack: '=?'
            },
            templateUrl: 'templates/back/back.html',
            controller: 'hlpBackController',
            link: function (scope, elem, attrs, ctrl) {
                if (!attrs.id) { attrs.id = 'back'; }
                if (!attrs.label) { attrs.label = 'Back'; }
                if (!attrs.title) { attrs.title = attrs.label; }
                if (!attrs.classes) { attrs.classes = 'back'; }

                scope.$on('$destroy', function () {
                    if (elem) {
                        angular.element(elem).remove();
                        elem = null;
                    }
                });
            }
        };
    }])

;